import axios from 'axios';

export const isIbbHostedUrl = value => {
  if (typeof value !== 'string') {
    return false;
  }
  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' && url.hostname.toLowerCase() === 'i.ibb.co';
  } catch (e) {
    return false;
  }
};

export const uploadPic = async e => {
  const file = e.target.files[0];
  const formData = new FormData();
  formData.append('file', file);
  const res = await axios.post(
    `${process.env.REACT_APP_API_URL}/image`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return res;
};

export const uploadPicFromUrl = async value => {
  if (isIbbHostedUrl(value)) {
    return { data: { url: value.trim() } };
  }

  const res = await axios.post(
    `${process.env.REACT_APP_API_URL}/image/fromUrl`,
    {
      url: value,
    }
  );
  return res;
};
